import {
  CbhIcon,
  type CbhIconProps,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";

interface LineItemProps {
  label: string;
  iconType: CbhIconProps["type"];
  hideDivider?: boolean;
  onClick?: () => void;
}

function LineItem(props: LineItemProps) {
  const { label, iconType, hideDivider = false, onClick } = props;

  return (
    <>
      <ListItemButton hideCallToActionIcon onClick={onClick}>
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <CbhIcon type={iconType} />
        </ListItemIcon>
        <ListItemText primary={<Text semibold>{label}</Text>} />
        <CbhIcon type="chevron-right" size="small" />
      </ListItemButton>
      {!hideDivider && <Divider color="primary" />}
    </>
  );
}

export function HelpAndSupport() {
  return (
    <Stack spacing={2} pt={4}>
      <Text bold variant="h5">
        Help &amp; Support
      </Text>
      <Stack>
        <LineItem
          hideDivider
          label="Chat with support"
          iconType="text-bubble"
          onClick={() => {
            void openZendeskMessaging();
          }}
        />
      </Stack>
    </Stack>
  );
}
